/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    code: "code",
    p: "p",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h2, {
      children: ["Missing Declarations for ", _jsx(_components.code, {
        children: "styled-components/native"
      }), "?"]
    }), "\n", _jsx(_components.p, {
      children: "If you're getting the error message:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-sh",
        children: "Could not find a declaration file for module 'styled-components/native'\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["In a React Native project using TypeScript, it is because you need to add ", _jsx(_components.code, {
        children: "@types/styled-components-react-native"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
